module.exports = __webpack_public_path__ + "img/bike_green.0c78fdc0.svg";